/**
 * Which user types are allowed to slice the finance pages (P&L, Revenue,
 * Monthly Estimates) by a city of their choice rather than being scoped to
 * their own assigned `city_id`.
 *
 * - 4: corporate/finance role with cross-city visibility.
 * - 31: CEO (Shashwat Gangwal) — needs all-city visibility for leadership reviews.
 *
 * Add new IDs here when more roles need the same capability.
 */
export const CITY_FILTER_USER_TYPES: ReadonlyArray<number> = [4, 31];

/**
 * Of the roles above, which ones must have an explicit city selected before
 * a default view makes sense? Role 4 always worked one city at a time, so it
 * keeps the auto-select-a-city + city-required-to-fetch behavior.
 *
 * Founders (31) are deliberately excluded: they need an all-city view by
 * default (auto-selecting a single city silently hid every other city's
 * facilities — see #56). A founder can still narrow to one city by picking
 * one manually; they're just never forced into one.
 */
const CITY_REQUIRED_USER_TYPES: ReadonlyArray<number> = [4];

export function canFilterByCity(userTypeId: number | null | undefined): boolean {
	return userTypeId != null && CITY_FILTER_USER_TYPES.includes(userTypeId);
}

export function requiresCitySelection(userTypeId: number | null | undefined): boolean {
	return userTypeId != null && CITY_REQUIRED_USER_TYPES.includes(userTypeId);
}
